import React, { useRef } from 'react';
import Work from './Work';
import './App.scss';
import { FaGithub, FaLinkedin, FaRegEnvelope } from 'react-icons/fa';
import Particles from 'react-tsparticles';

const particlesConfig : any = {
    fpsLimit: 60,
    interactivity: {
      detectsOn: "canvas",
      events: {
        onHover: {
          enable: true,
          mode: "repulse",
        },
        resize: true,
      },
      modes: {
        bubble: {
          distance: 400,
          duration: 2,
          opacity: 0.8,
          size: 40,
        },
        push: {
          quantity: 4,
        },
        repulse: {
          distance: 200,
          duration: 0.4,
        },
      },
    },
    particles: {
      color: {
        value: "#ffffff",
      },
      links: {
        color: "#ffffff",
        distance: 150,
        enable: true,
        opacity: 0.3,
        width: 1,
      },
      collisions: {
        enable: true,
      },
      move: {
        direction: "none",
        enable: true,
        outMode: "bounce",
        random: false,
        speed: 2,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          value_area: 800,
        },
        value: 20,
      },
      opacity: {
        value: 0.3,
      },
      shape: {
        type: "circle",
      },
      size: {
        random: true,
        value: 5,
      },
    },
    detectRetina: true,
}

function App() {
  const workRef = useRef<HTMLDivElement>(null)
  return (
    <div className="app">
      <Particles
        id="tsparticles"
        className="particles"
        options={particlesConfig}
      />
      <div className="header">Hey, I’m <span className="inline-span">Bruno Carvalhal</span>. <br /> A freelance software developer.</div>
      <div className="view-work-btn" onClick={() => { scrollToWorkSection(workRef);}}>View Work</div>
      <div className="work" ref={workRef}>
        <Work />
      </div>
      <div className="interested">
        Interested? Get in <a className="link" href="mailto:hello@brunocarvalhal.com">touch</a>!
      </div>
      <div className="footer">
        <div className="icons">
          <a className="footer-icon" href="https://www.github.com/ExtraBB">
            <FaGithub />
          </a>
          <a className="footer-icon" href="https://www.linkedin.com/in/brunocarvalhal/">
            <FaLinkedin />
          </a>
        </div>
        <div className="get-in-touch">
          <div className="get-in-touch-text">Get in touch!</div>
          <a className="envelope-link" href="mailto:hello@brunocarvalhal.com"><FaRegEnvelope /></a>
        </div>
      </div>
    </div>
  );
}

function scrollToWorkSection(ref: React.RefObject<HTMLDivElement>) {
  if(ref.current) {
    ref.current.scrollIntoView();
  }
}

export default App;
